module.exports = __webpack_public_path__ + "static/img/7.c3fa4ff.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/8/1/zh/7.png
// module id = CkGN
// module chunks = 0